import { render, staticRenderFns } from "./CourseHandle.vue?vue&type=template&id=5f53c1cb&"
import script from "./CourseHandle.vue?vue&type=script&lang=js&"
export * from "./CourseHandle.vue?vue&type=script&lang=js&"
import style0 from "./CourseHandle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports